import type { TyreLayoutSubjectKind } from '@chukua/common';
import { useState } from 'react';
import { TyreLayoutCanvas } from '../components/TyreLayoutCanvas';
import type { TyreDiagramAxle, TyreDiagramTowed, TyreDiagramView } from './TyrePositionDiagram';

interface TyreDiagramPanelProps {
  subjectKind: TyreLayoutSubjectKind;
  bodyStyle?: string | null;
  axles: TyreDiagramAxle[];
  selectedCode?: string | null;
  /** Omitted: the vehicle is shown for reference only. With a trailer drawn behind, `part` says whose code it is. */
  onSelect?: (code: string, part: 'main' | 'towed') => void;
  /** The vehicle's registration, shown on its number plates. */
  registration?: string | null;
  /** The vehicle's own paint. */
  color?: string | null;
  /** A truck's trailer, drawn coupled behind it on the same vehicle (gitaumoses4/chukua#390). */
  towed?: TyreDiagramTowed | null;
  /** Where the page keeps the panel; the editor's sticky placement is not wanted inside a modal or beside a table. */
  className?: string;
}

/** The vehicle in 3D with its view switch (3D, side, front, plan) for a screen that shows tyre positions: pick or point out a position on the vehicle itself. */
export function TyreDiagramPanel({
  subjectKind,
  bodyStyle = null,
  axles,
  selectedCode = null,
  onSelect,
  registration = null,
  color = null,
  towed = null,
  className,
}: TyreDiagramPanelProps) {
  const [view, setView] = useState<TyreDiagramView>('3d');
  return (
    <TyreLayoutCanvas
      className={className}
      subjectKind={subjectKind}
      bodyStyle={bodyStyle}
      axles={axles}
      view={view}
      onViewChange={setView}
      selectedCode={selectedCode}
      onSelect={onSelect ?? (() => undefined)}
      registration={registration}
      color={color}
      towed={towed}
    />
  );
}
